/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:absolute;bottom:0;z-index:10;display:block;width:100%;min-height:65px;overflow:hidden}@media (max-width:1439px){[_nghost-%COMP%]{min-height:60px}}@media (max-width:1023px){[_nghost-%COMP%]{min-height:50px}}@media (max-width:767px){[_nghost-%COMP%]{min-height:40px}}.bottom-curve[_ngcontent-%COMP%]{position:relative;bottom:-17px;z-index:1}.bottom-curve[_ngcontent-%COMP%]:after{display:block;width:100%;height:40px;position:absolute;bottom:-35px;background-color:var(--bg-background-color);content:\"\"}"];
export { styles as styles };
